import ProductionPeriod from '@/types/ProductionPeriod';
import ImageInfo from '@/types/ImageInfo';
import { ProductType } from '@/types/ProductType';
import Tag from '@/types/Tag';

export default class Product {

    public static listProductionPeriod(productionPeriods: ProductionPeriod[]) {
        const array = new Array<string>();
        productionPeriods.forEach( (productionPeriod: ProductionPeriod) => {
            if (productionPeriod.fromYear && !productionPeriod.toYear) {
                array.push(productionPeriod.fromYear + ' - ');
            } else if (productionPeriod.fromYear !== productionPeriod.toYear) {
                array.push(productionPeriod.fromYear + ' - ' + productionPeriod.toYear );
            } else if (productionPeriod.fromYear === productionPeriod.toYear) {
                array.push(productionPeriod.fromYear.toString());
            }
        });
        return array.join(', ');
    }

    public productId: string;
    public productType: ProductType;
    public productName: Map<string, string> = new Map<string, string>();
    public productionOrder: number;
    public productionPeriods: ProductionPeriod[] = new Array<ProductionPeriod>();
    public size: string;
    public productDescription: Map<string, string> = new Map<string, string>();
    public iconImage: ImageInfo;
    public images: ImageInfo[] = new Array<ImageInfo>();
    public numberLikes: number;
    public tags: Tag[];

}
